import * as React from 'react'
import { useCallback } from 'react'

import { BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'

interface Props {
  children: React.ReactNode
  color?: string
  dataTestId?: string
  flexWrap?: BoxProps['flexWrap']
  hideBorder?: boolean
  justifyContent?: any
  onClick?: () => void
  paddingY?: string
}

export function HeaderContainer(props: Props) {
  const {
    children,
    color,
    dataTestId,
    flexWrap,
    hideBorder,
    justifyContent,
    onClick,
    paddingY,
  } = props

  const getStyles = useCallback(() => {
    return {
      backgroundColor: color || '#FFFFFF',
      borderBottom: hideBorder ? 'none' : '1px solid #d1d1d6',
      padding: `${paddingY || '15px'} 18px`,
      cursor: onClick ? 'pointer' : 'inherit',
    }
  }, [color, hideBorder, onClick, paddingY])

  return (
    <Stack
      alignItems="center"
      flexWrap={flexWrap || 'initial'}
      justifyContent={justifyContent}
      onClick={onClick}
      sx={getStyles()}
      spacing={1}
      direction="row"
      data-test-id={dataTestId}
    >
      {children}
    </Stack>
  )
}
